import { useState } from "react";

export const useChatHistoryManager = ({
  setConversationId,
  conversationId,
  conversationIdRef,
  conversationIdParam,
  setSearchParams,
  refreshChats,
}: {
  setConversationId: (val: string) => void;
  conversationId: string;
  conversationIdRef: React.MutableRefObject<string | null>;
  conversationIdParam?: string;
  setSearchParams: (params: Record<string, string>) => void;
  refreshChats: () => void;
}) => {
  const [chatHistory, setChatHistory] = useState<any[]>([]);
  const [botMessageCount, setBotMessageCount] = useState(0);



  return {
    chatHistory,
    setChatHistory,
    botMessageCount,
    setBotMessageCount,
  };
};
